import { gql } from '@apollo/client';
export const CONVERT_CURRENCY = gql `
  query ConvertCurrency($spec: CurrencyConversionSpec!) {
    convertCurrency(spec: $spec) {
      exchangeRateDate
      totalExchangeRate
      exchangeRates
      baseCurrency
      quoteCurrency
      amountToConvert
      convertedAmount
    }
  }
`;
